/**
 * Transform svg file
 * to inline SVG
 **/
class DomainNav {
  constructor(windowSizes) {
    this.duration = 1.5;
    this.windowSizes = windowSizes;

    this.svgs = document.querySelectorAll(".svgIcon");
    if (this.svgs) {
      this.init();
    }
  }

  init() {
    const mySVGsToInject = document.querySelectorAll("img.inject-me");
    SVGInjector(this.svgs);
  }

  /** Resize Event */
  resize(windowSizes) {
    this.windowSizes = windowSizes;
  }
}

export default DomainNav;



// WEBPACK FOOTER //
// ./src/js/components/DomainNav.js